import { RenderAfterFirstPageLoad } from '@ms/yammer-page-route-telemetry';
import type { FC } from 'react';
import React from 'react';

import { LoadableNonCriticalAPICallingFeatures } from './lazyExports';

const DeferredAppFeatures: FC = () => (
  <RenderAfterFirstPageLoad>
    <LoadableNonCriticalAPICallingFeatures />
  </RenderAfterFirstPageLoad>
);

export default DeferredAppFeatures;
